import React from 'react';
import { Link } from 'react-router-dom';
import { GUIDE_GROUPS } from '../lib/guideArchitecture';

export default function GuideNavigator() {
  return (
    <section aria-labelledby="guide-navigator-title" className="max-w-[1180px] mx-auto px-4 py-12">
      <div className="mb-6 flex flex-wrap items-baseline justify-between gap-3 border-b border-[var(--border-strong)] pb-3">
        <h2 id="guide-navigator-title">Encontre o guia certo</h2>
        <Link to="/guias" className="inline-flex min-h-11 items-center text-sm text-[var(--primary)] underline">Ver todos os guias →</Link>
      </div>

      <ul className="grid gap-x-10 gap-y-5 md:grid-cols-2">
        {GUIDE_GROUPS.map((group) => (
          <li key={group.id} className="border-b border-[var(--border)] pb-5 last:border-b-0 md:[&:nth-last-child(-n+2)]:border-b-0">
            <Link to={`/guias#${group.id}`} className="group no-underline">
              <span className="block text-lg font-semibold text-[var(--primary)] group-hover:underline underline-offset-4">{group.title}</span>
              <span className="mt-1 block text-sm leading-relaxed text-[var(--text-muted)]">{group.description}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
